// @flow
import { PRODUCT_BREADCRUMB } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_BREADCRUMB } from 'Utils/request/requestDictionary';

export const productBreadcrumbResolver = {
  name: PRODUCT_BREADCRUMB,
  props(appContext: AppContext) {
    return {
      originalUrl() {
        return appContext.originalUrl;
      },
    };
  },
  resolve(
    appContext: AppContext,
    cmsProps: {
      resortId: string,
    },
    pageContext: PageContext,
  ) {
    const { productCountryPageUrl, productRegionPageUrl } = pageContext;
    const pageCountryQuery = productCountryPageUrl
      ? `
      countryPage: pageByUrl(pageUrl: "${productCountryPageUrl}") {
        pageCountry { breadcrumbLabel }
        url
      }`
      : '';
    const pageRegionQuery = productRegionPageUrl
      ? `
      regionPage: pageByUrl(pageUrl: "${productRegionPageUrl}") {
        pageRegion { breadcrumbLabel }
        url
      }`
      : '';
    const query = `query {
      resort(productId: "${cmsProps.resortId}"){
        name
      }
      ${pageCountryQuery}
      ${pageRegionQuery}
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_BREADCRUMB,
      strictErrors: false,
    });
  },
};
